import { Avatar as AntAvatar, Space } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import ProjectPlanGBG from 'assets/plan-bg.png';
import { Switch } from 'components/atoms/switch/switch';
import { useAccount } from 'hooks/use-account';
import { useAccountUpdateMutation } from 'queries';
import { getTheme } from './util';

const Avatar = styled(AntAvatar)`
  border: 1px solid #e5e5e5;
`;

const Container = styled.div`
  margin-top: var(--spacing-05);
`;

export const ProjectPlanBackgroundSettings = () => {
  const {
    metaData: { theme, showProjectPlanBackground = true, ...rest },
  } = useAccount();

  const initialThemeValues = getTheme(theme);
  const { mutate, isLoading } = useAccountUpdateMutation();

  const handleVisibilityChange = (checked) => {
    mutate({
      metaData: {
        ...rest,
        theme: theme ?? initialThemeValues,
        showProjectPlanBackground: checked,
      },
    });
  };

  return (
    <Container>
      <p>
        <FormattedMessage id="settings.organisation.appearance.plan_background.title" />
      </p>
      <div>
        <Space size="middle">
          <Avatar src={ProjectPlanGBG} shape="square" size={64} />
          <Space align="center">
            <Switch
              loading={isLoading}
              checked={showProjectPlanBackground}
              onChange={handleVisibilityChange}
              size="small"
            />
            <span>
              <FormattedMessage
                id={showProjectPlanBackground ? 'show' : 'hide'}
              />
            </span>
          </Space>
        </Space>
      </div>
    </Container>
  );
};
